import React, { useState } from 'react';
import useRecoveryData from './useRecoveryData';
import RecoveryOverview from './RecoveryOverview';
import SurgeryProfileForm from './SurgeryProfileForm';
import MilestoneTracker from './MilestoneTracker';
import PostOpMedicationList from './PostOpMedicationList';
import PostOpAppointmentList from './PostOpAppointmentList';
import DrainCatheterTracker from './DrainCatheterTracker';

const TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'profile', label: 'Surgery Profile' },
  { key: 'milestones', label: 'Milestones' },
  { key: 'medications', label: 'Medications' },
  { key: 'appointments', label: 'Appointments' },
  { key: 'devices', label: 'Devices' },
];

export default function RecoveryPage() {
  const { surgeryProfile, milestones, activeMeds, upcomingAppointments, hasSurgeryProfile, loading, refresh } = useRecoveryData();
  const [activeTab, setActiveTab] = useState(null);

  // Auto-select tab: if no surgery profile, start on profile tab; otherwise overview
  const currentTab = activeTab || (hasSurgeryProfile ? 'overview' : 'profile');

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white drop-shadow-sm">Recovery Tracker</h1>
        <p className="text-white/70 mt-1">
          {hasSurgeryProfile
            ? 'Track your post-surgery recovery journey'
            : 'Start by filling out your surgery profile'}
        </p>
      </div>

      {/* Tab navigation */}
      <div className="flex gap-1 overflow-x-auto pb-1">
        {TABS.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            className={`px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap transition
              ${currentTab === key
                ? 'bg-white/20 text-white'
                : 'text-white/50 hover:bg-white/10 hover:text-white/80'
              }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="glass rounded-2xl p-6">
        {currentTab === 'overview' && (
          <RecoveryOverview
            surgeryProfile={surgeryProfile}
            milestones={milestones}
            activeMeds={activeMeds}
            upcomingAppointments={upcomingAppointments}
          />
        )}

        {currentTab === 'profile' && (
          <SurgeryProfileForm
            profile={surgeryProfile}
            onSave={() => {
              refresh();
              setActiveTab('overview');
            }}
          />
        )}

        {currentTab === 'milestones' && <MilestoneTracker />}
        {currentTab === 'medications' && <PostOpMedicationList />}
        {currentTab === 'appointments' && <PostOpAppointmentList />}
        {currentTab === 'devices' && <DrainCatheterTracker />}
      </div>
    </div>
  );
}
